import type { CSSProperties } from "react";
import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

export function GiftSection({ data, copy, onOpenGift }: SectionRenderProps) {
  if (!data.gifts.enabled) return null;
  const style = { "--photo": `url("${resolveAssetPath(data.gifts.backgroundImage)}")` } as CSSProperties;
  return (
    <section className="gift band gift-photo-bg" id="gift" style={style}>
      <div className="section-inner gift-grid">
        <div><p className="eyebrow">Wedding Gift</p><h2 data-editor-section="gift" data-editor-field="gifts.title">{data.gifts.title}</h2><p data-editor-section="gift" data-editor-field="gifts.description">{data.gifts.description}</p></div>
        <button type="button" className="primary-btn dark-btn gift-open-large" onClick={onOpenGift}>
          <span>{copy.openGift}</span><span className="gift-arrow" aria-hidden="true">→</span>
        </button>
      </div>
    </section>
  );
}
